import merge from 'lodash/merge';
import { RED_500, GREEN_500, YELLOW_500, progressConfig } from '../../constants';
export var getProgressColor = props => {
  var value = props.value,
    progressColor = props.progressColor,
    _props$healthType = props.healthType,
    healthType = _props$healthType === void 0 ? 'none' : _props$healthType;
  var color = progressColor;
  if (healthType !== 'none') {
    if (value > 60) {
      color = healthType === 'health' ? GREEN_500 : RED_500;
    } else if (value > 20) {
      color = YELLOW_500;
    } else {
      color = healthType === 'health' ? RED_500 : GREEN_500;
    }
  }
  return color;
};
export var getProgressProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(progressConfig === null || progressConfig === void 0 ? void 0 : progressConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.progress) === null || _a === void 0 ? void 0 : _a[theme]);
  var value = props.value;
  if (value < 0) value = 0;
  if (value > 100) value = 100;
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    value
  });
};